import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, PagedResponse } from '@edl-development/edl-common';
import { CustomSupervisionAssignmentRequest } from '../../model/custom-supervision/custom-supervision-assignment-request.model';
import { PagedModel } from '../../model/base/paged.model';
import { PaetepApi } from '../paetep/paetep.api';
import { AssignmentDTO } from '../../model/assignments/assignment-management-dto.model';
import { AssignmentsRequestDTO } from '../../model/assignments/assignments-request-dto.model';
import { DEFAULT_ASSIGNMENT_REQUEST_DTO } from '../../assignments/common/constants/default-assignments-request-dto.const';
import { PaetepRoleAllowDenyPermissionsDTO } from '../../model/paetep-roles/paetep-role-allow-deny-permissions-dto.model';

const CONTROLLER_PATH = 'CustomSupervision';

@Injectable()
export class CustomSupervisionApi extends PaetepApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    private get path(): string {
        return `${this.baseUri}/${CONTROLLER_PATH}`;
    }

    getAssignments(assignmentRequest: AssignmentsRequestDTO) {
        const body = { ...DEFAULT_ASSIGNMENT_REQUEST_DTO, ...assignmentRequest };
        return this.http.post<PagedResponse<AssignmentDTO>>(`${this.path}/get`, body);
    }

    getRolesICanManage() {
        return this.http.get<PaetepRoleAllowDenyPermissionsDTO>(`${this.path}/rolesICanManage`);
    }

    getAllMyEmployeeIds() {
        return this.http.get<string[]>(`${this.path}/allMyEmployeeIds`);
    }

    getMyEmployeeAssignments(paging: PagedModel) {
        const params = this.generatePagingParams(paging);

        return this.http.get<PagedResponse<AssignmentDTO>>(`${this.path}/myEmployees`, { params });
    }

    /**
     * Returns a list of roles that given user can have as target peers
     * @param userId 
     * @returns List of PAETEPRoleType
     */
    getRolesUserCanSupervise(userId: string) {
        return this.http.get<PaetepRoleAllowDenyPermissionsDTO>(`${this.path}/rolesUserCanSupervise/${userId}`);
    }

    addAssignment(assignment: CustomSupervisionAssignmentRequest) {
        return this.http.post(`${this.path}/addSupervisionAssignments`, assignment);
    }

    removeAssignment(assignment: CustomSupervisionAssignmentRequest) {
        return this.http.post(`${this.path}/removeSupervisionAssignments`, assignment);
    }
}